import { WalkingStatuses } from '~/types/common';

export const walkingCardStatus: { value: WalkingStatuses } = {
  value: WalkingStatuses.waitingPayment,
};
